import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

// modules
import auth_mod from '@vigilantapps/ui-library/src/store/auth'
import filters_mod from '@vigilantapps/ui-library/src/services/filters/vuex'
import navbar_mod from '@/store/navbar'
import deviceMapping_mod from '@/store/device-mapping'
import policies_mod from '@/store/policies'
import rules_mod from '@/store/rules'
import filterSuggestions_mod from '@vigilantapps/ui-library/src/services/filters/vuex_suggestions'
import deviceCache_mod from '@/store/device-cache'
import messenger_mod from '@/store/messenger'
import userSettings_mod from '@/store/user-settings'

Vue.use(Vuex)

// vuex-persist
const vuexCfg = new VuexPersistence({
  storage: window.localStorage,
  modules: ['auth', 'filters', 'navbar', 'policies', 'filterSuggestions', 'messenger', 'userSettings'],
})

export default new Vuex.Store({
  plugins: [vuexCfg.plugin],
  modules: {
    auth: auth_mod,
    filters: filters_mod,
    navbar: navbar_mod,
    deviceMapping: deviceMapping_mod,
    policies: policies_mod,
    rules: rules_mod,
    filterSuggestions: filterSuggestions_mod,
    deviceCache: deviceCache_mod,
    messenger: messenger_mod,
    userSettings: userSettings_mod,
  }
})
